import ReadOnlyInput from '@core/components/Inputs/ReadOnlyInput';
import { Grid } from '@material-ui/core';
import InputMonetario from 'app/components/Input/InputMonetario';
import { getCurrency } from 'app/utils/monetarioUtil';
import React from 'react';

const ContaReceberAcrescimosDescontos = ({ values, onChange, onBlur, disabled }) => {
  const calcularValorRecebido = (values) => {
    const acrescimoDesconto =
      (values?.baixa?.juros?.valorBruto || 0) +
        (values?.baixa?.multa?.valorBruto || 0) +
        (values?.baixa?.correcaoMonetaria?.valorBruto || 0) -
        (values?.baixa?.desconto?.valorBruto || 0) || 0;

    return isNaN(values?.baixa?.valorRecebido + acrescimoDesconto)
      ? '-'
      : getCurrency(values?.baixa?.valorRecebido + acrescimoDesconto);
  };

  return (
    <>
      <Grid item xs={12} sm={2}>
        <InputMonetario
          fullWidth
          id="baixa.juros.valorBruto"
          label="Juros (R$)"
          onBlur={onBlur}
          value={values?.baixa?.juros?.valorBruto}
          handleChange={onChange}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <InputMonetario
          fullWidth
          id="baixa.multa.valorBruto"
          label="Multa (R$)"
          onBlur={onBlur}
          value={values?.baixa?.multa?.valorBruto}
          handleChange={onChange}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <InputMonetario
          fullWidth
          id="baixa.desconto.valorBruto"
          label="Desconto (R$)"
          onBlur={onBlur}
          value={values?.baixa?.desconto?.valorBruto}
          handleChange={onChange}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <InputMonetario
          fullWidth
          id="baixa.correcaoMonetaria.valorBruto"
          label="Correção monetária (R$)"
          onBlur={onBlur}
          value={values?.baixa?.correcaoMonetaria?.valorBruto}
          handleChange={onChange}
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={12} sm={2}>
        <ReadOnlyInput
          fullWidth
          id="valorRecebido"
          label="Valor recebido (R$)"
          onBlur={onBlur}
          value={calcularValorRecebido(values)}
          handleChange={onChange}
        />
      </Grid>
    </>
  );
};
export default ContaReceberAcrescimosDescontos;
